/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import React from 'react';
import { FormInputGroup } from '../../../react/form_input_group.jsx';
import { FormRow } from '../../../react/form_row.jsx';

export class PromoCodeForm extends React.Component {


      constructor(...args) {
        super(...args);
        this.onRemovePromoCode = this.onRemovePromoCode.bind(this);
        this.renderPromoCodeStatus = this.renderPromoCodeStatus.bind(this);
        this._setInputRef = this._setInputRef.bind(this);
        this.onApplyPromoCode = this.onApplyPromoCode.bind(this);
this.renderOpenForm = this.renderOpenForm.bind(this);
      }

      render() {
        if (this.props.activePromoCode) {
          return this.renderPromoCodeStatus();
        } 
          return this.renderOpenForm();
        
      }

      onRemovePromoCode(event) {
        event.preventDefault();
        return (typeof this.props.onRemovePromoCode === 'function' ? this.props.onRemovePromoCode() : undefined);
      }

      renderPromoCodeStatus() {
        return <FormInputGroup className="promo-group-wrap">
          <FormRow title="Promo Code: ">
            {this.props.promoCode}
            <a className="promo_remove em-link" href="#" onClick={this.onRemovePromoCode}>{this.props.loading ? "Removing..." : "Remove"}</a>
          </FormRow>
        </FormInputGroup>;
      }

      _setInputRef(element) { return this.promoCodeInput = element; }

      onApplyPromoCode(event) {
        event.preventDefault();

        const new_promo_code = this.promoCodeInput.value;
        return (typeof this.props.onApplyPromoCode === 'function' ? this.props.onApplyPromoCode(new_promo_code) : undefined);
      }

      renderOpenForm() {
        const error_message = (() => { switch (this.props.promoCodeError) {
          case 'invalid':
            return "That promo code is invalid";
          case 'expired':
            return "That promo code has expired";
          default:
            return null;
        } })();

        return <div className="promo_code">
            <div className="em-input_container">
              <div className={error_message ? "em-input-floating em-error" : "em-input-floating"}>
                <input type="text" id="promo_code" defaultValue={this.props.promoCode} ref={this._setInputRef} placeholder="Add promo code" />
                <label htmlFor="promo_code">Promo code</label>
                <i className="fas fa-ticket-alt" aria-hidden="true"></i>
              </div>
              {error_message && <span className="error_marker" role="alert">{error_message}</span>}
            </div>

          <div className="action_button">
            <button className="em-link" onClick={this.onApplyPromoCode}>{this.props.loading ? "Checking..." : "Apply promo"}
              <i className="fas fa-long-arrow-alt-right"></i>
            </button>
          </div>
        </div>;
      }
    }
